document.addEventListener('DOMContentLoaded', function () {
  
    // 모바일 화면에서 'mtoggle' 클래스가 없는 경우 프로모션 배너를 숨김
    const mobileScreenWidth = 768;
    const promoBannerLists = document.querySelectorAll('#root .shopify-section-header #nav>ul>li>ul li ul li.sg-nav-banner');
    const promoMtoggle = document.querySelectorAll('.m2a #root .shopify-section-header #nav > ul > li.sub');

    if (typeof promoBannerLists !== 'undefined' && promoBannerLists.length > 0) {
        promoBannerLists.forEach(function (ul) {
            if (window.innerWidth <= mobileScreenWidth) {
                let hasMtoggle = false;

                promoMtoggle.forEach(function (toggle) {
                    if (toggle.classList.contains('mtoggle')) {
                        hasMtoggle = true;
                    }
                });

                if (!hasMtoggle) {
                    ul.style.display = 'none';
                }
            }
        });
    }
  
});